module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "50px",
      "background-color": "#eee"
    }
  }, [_c('h1', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Förderer")]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "src": _vm.$_getIcon('dfg_logo_schriftzug_blau_foerderung_4c.jpg')
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31177483","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Foerderer.vue
// module id = 1963
// module chunks = 1